import React from 'react';
import { startOfWeek, format, parse } from 'date-fns';

/**
 * DatePicker component for selecting a week
 * @param {Object} props - Component props
 * @param {string} props.weekStart - Current selected week start date (YYYY-MM-DD)
 * @param {Function} props.onWeekChange - Callback when week changes
 */
const DatePicker = ({ weekStart, onWeekChange }) => {
  const handleChange = (e) => {
    const selectedDate = parse(e.target.value, 'yyyy-MM-dd', new Date());
    const weekStartDate = startOfWeek(selectedDate, { weekStartsOn: 0 }); // 0 = Sunday
    const formattedDate = format(weekStartDate, 'yyyy-MM-dd');
    onWeekChange(formattedDate);
  };

  return (
    <div className="date-picker">
      <label htmlFor="week-selector">Week Starting: </label>
      <input
        id="week-selector"
        type="date"
        value={weekStart}
        onChange={handleChange}
        className="date-input"
      />
    </div>
  );
};

export default DatePicker;